<script setup lang="ts">
import type { IconsKeys } from '../icon/types'

type Props = {
  prependText?: string
  centerText?: string
  appendText?: string
  prependIcon?: IconsKeys
  appendIcon?: IconsKeys
}

type Emits = {
  (fn: 'onClickPrepend'): void
  (fn: 'onClickAppend'): void
}

defineProps<Props>()

const emit = defineEmits<Emits>()
</script>

<template>
  <div class="app-top-bar">
    <div class="app-top-bar__section">
      <the-button
        v-if="prependIcon"
        data-test-id="top-bar-prepend-button"
        variant="transparent"
        size="xxs"
        width="28"
        height="28"
        :icon="prependIcon"
        @click="emit('onClickPrepend')"
      />

      <span
        v-if="prependText"
        data-test-id="top-bar-prepend-text"
        class="app-top-bar__text"
      >
        {{ prependText }}
      </span>
    </div>

    <div class="app-top-bar__section">
      <span
        v-if="centerText"
        data-test-id="top-bar-center-text"
        class="app-top-bar__text"
      >
        {{ centerText }}
      </span>
    </div>

    <div class="app-top-bar__section">
      <span
        v-if="appendText"
        data-test-id="top-bar-append-text"
        class="app-top-bar__text"
      >
        {{ appendText }}
      </span>

      <the-button
        v-if="appendIcon"
        data-test-id="top-bar-append-button"
        variant="transparent"
        size="xxs"
        width="28"
        height="28"
        :icon="appendIcon"
        @click="emit('onClickAppend')"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.app-top-bar {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 6px 20px;
  color: var(--ui-text-primary);
  background-color: var(--ui-color-white);

  &__section {
    display: flex;
    gap: 12px;
    align-items: center;
    min-width: 28px;
    min-height: 28px;
  }

  &__text {
    max-width: 185px;
    font-size: 18px;
    font-weight: 800;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.01em;
    user-select: none;
  }
}
</style>
